import { Button, ButtonGroup, type IModalProps, Modal } from '@lego/klik-ui';
import type { ReactNode } from 'react';

export type ConfirmationDialogProps = {
  onConfirmed: () => void;
  header: string;
  body: ReactNode;
};

export const ConfirmationDialog = ({
  header,
  body,
  onConfirmed,
  isOpen,
  onClose,
  size,
  variant,
}: ConfirmationDialogProps & Omit<IModalProps, 'children'>) => {
  return (
    <Modal
      hideIcon={true}
      isOpen={isOpen}
      onClose={onClose}
      size={size ?? 'xl'}
      variant={variant ?? 'warning'}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header fontSize="xl">{header}</Modal.Header>
        <Modal.CloseButton />

        <Modal.Body fontSize="md">{body}</Modal.Body>

        <Modal.Footer>
          <ButtonGroup>
            <Button colorScheme="warning" onClick={onConfirmed}>
              Confirm
            </Button>
            <Button onClick={onClose} variant="outline">
              Cancel
            </Button>
          </ButtonGroup>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
